<template>
    <div class="plugin-slider-mention-item swiper-slide">
        <div class="plugin-slider-mention-item__content">
            <div class="plugin-slider-mention-item__content-stars">
                <icon name="star" v-for="n in starsCount" :key="n" />
            </div>
            <div class="plugin-slider-mention-item__content-text">
                {{ scoreFormatted }} из 5
            </div>
        </div>
        <div class="plugin-slider-mention-item__media">
            <img v-bind:src="image" alt="" />
            <plugin-home-common-arrow-link
                text="К отзывам"
                v-bind:url="link"
                theme="primary"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'plugin-slider-review-item',
    props: {
        score: {
            type: String,
        },
        link: {
            type: String,
        },
        image: {
            type: String,
        },
    },
    data: () => ({

    }),
    computed: {
        scoreFormatted() {
            return this.score.replace(',', '.');
        },
        starsCount() {
            return Math.ceil(Number(this.scoreFormatted));
        },
    },
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-slider-mention-item {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 320px;
    height: 280px;

    border: 1px solid @color-gray-light-secondary;
    border-radius: @border-radius-xxl;

    background-color: white;
    overflow: hidden;

    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        height: 140px;
        padding-top: 32px;
        background-color: #F9F6FE;
        overflow: hidden;
        border-bottom: 1px solid @color-gray-light-secondary;
        &-stars {
            display: flex;
            gap: 6px;
            font-size: 3.6rem;
            color: @color-primary;
        }
        &-text {
            .typography-medium();
        }
    }
    &__media {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        flex-shrink: 0;
        padding-top: 36px;
        img {
            height: 36px;
        }
    }
    @media @media-md-down {
        max-width: 240px;
        border-radius: @border-radius-xll;
        &__content {
            padding-top: 36px;
            &-stars {
                gap: 4px;
                font-size: 3rem;
            }
            &-text {
                .typography-small();
            }
        }
    }
}
</style>
